function Cirles({ xCoor, yCoor }) {
  return (
    <div
      style={{ left: `${xCoor}px`, top: `${yCoor}px` }}
      className="circle1"
    ></div>
  );
}

export default Cirles;
